import { registerBlockType } from "@wordpress/blocks";
import {
    useBlockProps,
    InspectorControls,
    PanelColorSettings,
} from "@wordpress/block-editor";
import { PanelBody, __experimentalView as View } from "@wordpress/components";
import UnitRange from "./components/UnitRange";

registerBlockType("kamikaze/bar-block", {
    apiVersion: 2,
    title: "Bar",
    icon: "minus",
    category: "design",
    supports: {
        html: false,
        reusable: false,
    },

    attributes: {
        width: {
            type: "object",
            default: { value: 100, unit: "%" },
        },
        height: {
            type: "object",
            default: { value: 2, unit: "px" },
        },
        backgroundColor: {
            type: "string",
            default: "#000000",
        },
        marginTop: {
            type: "object",
            default: { value: 0, unit: "px" },
        },
        marginBottom: {
            type: "object",
            default: { value: 0, unit: "px" },
        },
        borderRadius: {
            type: "object",
            default: { value: 0, unit: "px" },
        },
    },

    edit: function BarEdit({ attributes, setAttributes }) {
        const {
            width,
            height,
            backgroundColor,
            marginTop,
            marginBottom,
            borderRadius,
        } = attributes;

        const blockProps = useBlockProps({
            style: {
                width: `${width.value}${width.unit}`,
                height: `${height.value}${height.unit}`,
                backgroundColor,
                marginTop: `${marginTop.value}${marginTop.unit}`,
                marginBottom: `${marginBottom.value}${marginBottom.unit}`,
                borderRadius: `${borderRadius.value}${borderRadius.unit}`,
            },
        });

        return (
            <>
                <InspectorControls>
                    <PanelBody title="Ustawienia bara" initialOpen={true}>
                        <View style={{ padding: "15px 0 0 0" }}>
                            <UnitRange
                                label="Szerokość"
                                rangeValue={width.value}
                                unitValue={width}
                                onRangeChange={(value) =>
                                    setAttributes({
                                        width: { ...width, value },
                                    })
                                }
                                onUnitChange={(value) =>
                                    setAttributes({ width: value })
                                }
                                min={0}
                                max={100}
                                units={["%", "px", "vw"]}
                                __nextHasNoMarginBottom
                            />
                        </View>

                        <View style={{ padding: "10px 0" }}>
                            <UnitRange
                                label="Wysokość"
                                rangeValue={height.value}
                                unitValue={height}
                                onRangeChange={(value) =>
                                    setAttributes({
                                        height: { ...height, value },
                                    })
                                }
                                onUnitChange={(value) =>
                                    setAttributes({ height: value })
                                }
                                min={1}
                                max={100}
                                __nextHasNoMarginBottom
                            />
                        </View>

                        <View style={{ padding: "10px 0" }}>
                            <UnitRange
                                label="Zaokrąglenie rogów"
                                rangeValue={borderRadius.value}
                                unitValue={borderRadius}
                                onRangeChange={(value) =>
                                    setAttributes({
                                        borderRadius: {
                                            ...borderRadius,
                                            value,
                                        },
                                    })
                                }
                                onUnitChange={(value) =>
                                    setAttributes({ borderRadius: value })
                                }
                                min={0}
                                max={50}
                                __nextHasNoMarginBottom
                            />
                        </View>

                        <View style={{ padding: "10px 0" }}>
                            <UnitRange
                                label="Margines górny"
                                rangeValue={marginTop.value}
                                unitValue={marginTop}
                                onRangeChange={(value) =>
                                    setAttributes({
                                        marginTop: { ...marginTop, value },
                                    })
                                }
                                onUnitChange={(value) =>
                                    setAttributes({ marginTop: value })
                                }
                                min={0}
                                max={100}
                                __nextHasNoMarginBottom
                            />
                        </View>

                        <View style={{ padding: "10px 0" }}>
                            <UnitRange
                                label="Margines dolny"
                                rangeValue={marginBottom.value}
                                unitValue={marginBottom}
                                onRangeChange={(value) =>
                                    setAttributes({
                                        marginBottom: {
                                            ...marginBottom,
                                            value,
                                        },
                                    })
                                }
                                onUnitChange={(value) =>
                                    setAttributes({ marginBottom: value })
                                }
                                min={0}
                                max={100}
                                __nextHasNoMarginBottom
                            />
                        </View>

                        <View style={{ padding: "10px 0" }}>
                            <PanelColorSettings
                                title=""
                                colorSettings={[
                                    {
                                        value: backgroundColor,
                                        onChange: (value) =>
                                            setAttributes({
                                                backgroundColor: value,
                                            }),
                                        label: "Kolor tła",
                                    },
                                ]}
                            />
                        </View>
                    </PanelBody>
                </InspectorControls>
                <div {...blockProps} />
            </>
        );
    },

    save: function BarSave({ attributes }) {
        const {
            width,
            height,
            backgroundColor,
            marginTop,
            marginBottom,
            borderRadius,
        } = attributes;

        const blockProps = useBlockProps.save({
            style: {
                width: `${width.value}${width.unit}`,
                height: `${height.value}${height.unit}`,
                backgroundColor,
                marginTop: `${marginTop.value}${marginTop.unit}`,
                marginBottom: `${marginBottom.value}${marginBottom.unit}`,
                borderRadius: `${borderRadius.value}${borderRadius.unit}`,
            },
        });

        return <div {...blockProps} />;
    },
});
